import { useState, useEffect } from "react";
import { TextField, Grid, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JOrder,
  resetForm,
  setOrderItemDiscountDialog,
} from "../../../../app/slices/jomla/orderSlice";
import { NumericFormat } from "react-number-format";
import { toNumber } from "../../../../helpers/toNumber";
import { HiOutlineReceiptPercent, HiOutlineCalculator } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const EditOrderItemDiscountForm = () => {
  const dispatch = useDispatch();

  const _JOrder = useSelector((state) => state.jOrder.orderItemDiscount);

  const [loading, setLoading] = useState(false);

  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _JOrder.form,
  });

  const onSubmit = (data) => {
    setLoading(true);
    dispatch(
      JOrder.editOrderItemDiscount(
        _JOrder.form.id,
        {
          discount: data.total_discount ?? 0,
        },
        _JOrder.form.orderId,
        "orderDetails"
      )
    )
      .then((x) => setLoading(false))
      .catch((e) => setLoading(false));
  };

  useEffect(() => {
    reset({ ..._JOrder.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_JOrder.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setOrderItemDiscountDialog({}));
  };

  return (
    <FormDialog
      open={_JOrder.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineReceiptPercent />}
      title={"تعديل الخصم "}
      subtitle={"ملاحظة: قيمة الخصم المدخلة هي قيمة الخصم للقطعة الواحدة"}
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      loading={_JOrder.loading}
    >
      <SectionCard icon={<HiOutlineCalculator />} title="الخصم">
        <Grid item xs={12} sm={6}>
          <Controller
            control={control}
            name={"total_discount_percent"}
            render={({ field }) => (
              <NumericFormat
                thousandSeparator
                customInput={TextField}
                value={field.value}
                onChange={(e) => {
                  setValue(
                    "total_discount",
                    (toNumber(e.target.value) / 100) * _JOrder.form.price
                  );
                  setValue("total_discount_percent", toNumber(e.target.value));
                }}
                valueIsNumericString={true}
                allowNegative={false}
                fullWidth
                label="الخصم"
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">%</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            control={control}
            name={"total_discount"}
            render={({ field }) => (
              <NumericFormat
                thousandSeparator
                customInput={TextField}
                value={field.value}
                onChange={(e) => {
                  setValue(
                    "total_discount_percent",
                    (toNumber(e.target.value) / _JOrder.form.price) * 100
                  );
                  setValue("total_discount", toNumber(e.target.value));
                }}
                valueIsNumericString={true}
                allowNegative={false}
                fullWidth
                label="الخصم"
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default EditOrderItemDiscountForm;
